// Totes On Time - theme.js
(function(){
  'use strict';

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // FAQ accordion - close others when one opens (optional, native <details> works without this)
  // Uncomment below if you want exclusive open behavior:
  // document.querySelectorAll('.faq-item').forEach(function(d){
  //   d.addEventListener('toggle', function(){
  //     if (d.open) {
  //       document.querySelectorAll('.faq-item[open]').forEach(function(o){
  //         if (o !== d) o.removeAttribute('open');
  //       });
  //     }
  //   });
  // });
})();
